/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Category_AllInputs */

const en_keyword_optimizer_category_all = /** @type {(inputs: Keyword_Optimizer_Category_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Keywords`)
};

const de_keyword_optimizer_category_all = /** @type {(inputs: Keyword_Optimizer_Category_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Keywords`)
};

const fr_keyword_optimizer_category_all = /** @type {(inputs: Keyword_Optimizer_Category_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Keywords`)
};

const es_keyword_optimizer_category_all = /** @type {(inputs: Keyword_Optimizer_Category_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Keywords`)
};

const it_keyword_optimizer_category_all = /** @type {(inputs: Keyword_Optimizer_Category_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Keywords`)
};

const nl_keyword_optimizer_category_all = /** @type {(inputs: Keyword_Optimizer_Category_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Keywords`)
};

const pl_keyword_optimizer_category_all = /** @type {(inputs: Keyword_Optimizer_Category_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Keywords`)
};

const fi_keyword_optimizer_category_all = /** @type {(inputs: Keyword_Optimizer_Category_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Keywords`)
};

const da_keyword_optimizer_category_all = /** @type {(inputs: Keyword_Optimizer_Category_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Keywords`)
};

const sv_keyword_optimizer_category_all = /** @type {(inputs: Keyword_Optimizer_Category_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Keywords`)
};

/**
* | output |
* | --- |
* | "All Keywords" |
*
* @param {Keyword_Optimizer_Category_AllInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_category_all = /** @type {((inputs?: Keyword_Optimizer_Category_AllInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Category_AllInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_category_all(inputs)
	if (locale === "fr") return fr_keyword_optimizer_category_all(inputs)
	if (locale === "es") return es_keyword_optimizer_category_all(inputs)
	if (locale === "it") return it_keyword_optimizer_category_all(inputs)
	if (locale === "nl") return nl_keyword_optimizer_category_all(inputs)
	if (locale === "pl") return pl_keyword_optimizer_category_all(inputs)
	if (locale === "fi") return fi_keyword_optimizer_category_all(inputs)
	if (locale === "da") return da_keyword_optimizer_category_all(inputs)
	if (locale === "sv") return sv_keyword_optimizer_category_all(inputs)
	return en_keyword_optimizer_category_all(inputs)
});